import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./About.css";

const About = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div
      id="about"
      className="grid grid-cols-1 lg:grid-cols-2 gap-20 custom-bg text-white p-5 md:p-20"
    >
      <div data-aos="fade-up">
        <p className="text-4xl font-semibold my-5 text-green-400 border-l-8 pl-5 border-green-400 inline-block">
          About Me
        </p>
        <p className=" custom-shadow p-5 text-gray-400 first-letter:text-3xl first-letter:font-bold leading- text-justify text-xl mt-5">
        Hello, I'm Habib Ullah, a MERN stack developer. I hold a BSc degree in CSE from Green University of Bangladesh and have been learning web development since 2020/21. During this time, I've completed several personal projects that have helped me develop my skills in React.js, Node.js, Express.js, and MongoDB.
<br /><br />
As a dedicated learner, I'm committed to keeping up with the latest trends in web development and continually expanding my knowledge and skills. My goal is to create visually appealing and user-friendly web applications that provide a seamless experience for users. You can check out some of my work on my GitHub profile.Thank you for taking the time to learn a little more about me, and I look forward to the opportunity to work with you. 
        </p>
      </div>
      <div data-aos="fade-up">
        <p className="text-4xl font-semibold my-5 text-green-400 border-l-8 pl-5 border-green-400 inline-block">
          Skills
        </p>
        <div className="flex gap-16 flex-wrap items-center justify-center md:justify-start mt-5">
          <div className=" p-4 relative custom-shadow image-container">
            <img
              width={"50px"}
              src={"https://i.ibb.co/qD8fkxd/html-5.png"}
              alt=""
            />
            <p className="overlay ease-in duration-300 absolute bottom-0 left-0 right-0 overflow-hidden w-full h-0 ">
              <span className="inner-item">HTML5</span>
            </p>
          </div>
          <div className="p-4 relative custom-shadow image-container ">
            <img
              width={"50px"}
              src={"https://i.ibb.co/ZxtKGvJ/css-3.png"}
              alt=""
            />
            <p className="overlay ease-in duration-300 absolute bottom-0 left-0 right-0 overflow-hidden w-full h-0 ">
              <span className="inner-item">CSS3</span>
            </p>
          </div>
          <div className="p-4 relative custom-shadow image-container ">
            <img
              width={"50px"}
              src={"https://i.ibb.co/FzQzg0Z/bootstrap.png"}
              alt=""
            />
            <p className="overlay ease-in duration-300 absolute bottom-0 left-0 right-0 overflow-hidden w-full h-0 ">
              <span className="inner-item">Bootstrap5</span>
            </p>
          </div>
          <div className="p-4 relative custom-shadow image-container ">
            <img
              width={"50px"}
              src={"https://i.ibb.co/vZm7Scd/Tailwind-CSS-Logo-svg.png"}
              alt=""
            />
            <p className="overlay ease-in duration-300 absolute bottom-0 left-0 right-0 overflow-hidden w-full h-0 ">
              <span className="inner-item">Tailwind</span>
            </p>
          </div>
          <div className="p-4 relative custom-shadow image-container ">
            <img
              width={"50px"}
              src={"https://i.ibb.co/7ynK6Gw/js.png"}
              alt=""
            />
            <p className="overlay ease-in duration-300 absolute bottom-0 left-0 right-0 overflow-hidden w-full h-0 ">
              <span className="inner-item">JavaScript</span>
            </p>
          </div>
          <div className="p-4 relative custom-shadow image-container ">
            <img
              width={"50px"}
              src={"https://i.ibb.co/mNZ3ZPQ/physics.png"}
              alt=""
            />
            <p className="overlay ease-in duration-300 absolute bottom-0 left-0 right-0 overflow-hidden w-full h-0 ">
              <span className="inner-item">React</span>
            </p>
          </div>
          <div className="p-4 relative custom-shadow image-container ">
            <img
              width={"50px"}
              src={"https://i.ibb.co/kJZD4kV/nodejs.png"}
              alt=""
            />
            <p className="overlay ease-in duration-300 absolute bottom-0 left-0 right-0 overflow-hidden w-full h-0 ">
              <span className="inner-item">Node JS</span>
            </p>
          </div>
          <div className="p-4 relative custom-shadow image-container ">
            <img
              width={"50px"}
              src={"https://i.ibb.co/N31mf7D/express.png"}
              alt=""
            />
            <p className="overlay ease-in duration-300 absolute bottom-0 left-0 right-0 overflow-hidden w-full h-0 ">
              <span className="inner-item">Express JS</span>
            </p>
          </div>
          <div className="p-4 relative custom-shadow image-container ">
            <img
              width={"50px"}
              src={"https://i.ibb.co/3cDdsM1/mongodb.png"}
              alt=""
            />
            <p className="overlay ease-in duration-300 absolute bottom-0 left-0 right-0 overflow-hidden w-full h-0 ">
              <span className="inner-item">MongoDB</span>
            </p>
          </div>
          <div className="p-4 relative custom-shadow image-container ">
            <img
              width={"50px"}
              src={"https://i.ibb.co/xmSGtGJ/typescript.png"}
              alt=""
            />
            <p className="overlay ease-in duration-300 absolute bottom-0 left-0 right-0 overflow-hidden w-full h-0 ">
              <span className="inner-item">TypeScript</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
